import { createReducer, on } from "@ngrx/store";
import { Users } from "src/app/data/models";
import { RespondUser } from "src/app/data/models/respond/respond.model";
import * as userActions from './user.actions';
import { UserPermissionViewModel } from "src/app/data/models/access-permission/accessPermissionViewModel";

export interface UserState {
    currentUser?: Users;
    respondUser?: RespondUser;
    permissions?: UserPermissionViewModel;
    originalUser?: Users;
    currentUserFeatureIds?: number[]; // feature ids belonging to the logged-in (or emulated) user
};

export const featureKey = 'user';

const initialState: UserState = {
}

export const reducers = createReducer(initialState,
    on(userActions.userLoggedIn, (state, { user, respondUser }) => ({ ...state, currentUser: user, respondUser })),
    on(userActions.userLoggedOut, (_) => ({ ...initialState })),
    on(userActions.userEmulationStarted, (state, { emulatedUser }) => ({ ...state, currentUser: emulatedUser, originalUser: state.currentUser })),
    on(userActions.userEmulationStopped, (state) => ({ ...state, currentUser: state.originalUser, originalUser: undefined })),
    on(userActions.userPermissionsUpdated, (state, { permissions }) => ({ ...state, permissions })),
    on(userActions.currentUserFeaturesUpdated, (state, { featureIds }) => ({ ...state, currentUserFeatureIds: featureIds }))
)